import api from './api';

export const register = (data) => api.post('/auth/register', data);
export const login = (data) => api.post('/auth/login', data);
export const updateUserActiveStatus = (userId, isActive) => 
    api.put(`/users/current/users/${userId}/active-status`, { isActive });
